import { API_ENDPOINT } from "@/constants/appConstants";
import { PROFILE_PERFORMANCE_ACTIVITY_LEVEL_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { ActivityLevelResponse } from "../types";

export const getActivityLevel = async <T>(): Promise<T | Error> => {
  try {
    if (typeof window === "undefined") {
      throw new Error("Window is not available");
    }

    const response = await fetch(
      API_ENDPOINT(window.location.host).middleware.activityLevel,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: T = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching activity level data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const useActivityLevel = (): UseQueryResult<
  ActivityLevelResponse | Error
> => {
  return useQuery({
    queryKey: [PROFILE_PERFORMANCE_ACTIVITY_LEVEL_QUERY_KEY],
    queryFn: () => getActivityLevel<ActivityLevelResponse>(),
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
